// extracted by mini-css-extract-plugin
export default {"agreement":"zNy9BQ2O"};